import axios from 'axios'

export const state = {
  usersStats: null,
  usersStatsPagination: null,
}

export const getters = {
  usersStats: (state) => state.usersStats,
  usersStatsPagination: (state) => state.usersStatsPagination,
}

export const mutations = {
  SET_USERS_STATS(state, usersStats) {
    state.usersStats = usersStats
  },

  SET_PAGINATION(state, headers) {
    state.usersStatsPagination = {
      currentPage: parseInt(headers['x-current-page']),
      nextPage: parseInt(headers['x-next-page']),
      prevPage: parseInt(headers['x-prev-page']),
      totalItems: parseInt(headers['x-total-items']),
      totalPages: parseInt(headers['x-total-pages']),
      perPage: parseInt(headers['x-per-page']),
    }
  },
}

export const actions = {
  fetchAllUsersStats({ commit, state, rootState }, payload) {
    return axios
      .get('/api/users_stats', {
        params: payload,
      })
      .then((response) => {
        const usersStats = response.data
        commit('SET_USERS_STATS', usersStats)
        commit('SET_PAGINATION', response.headers)
        return usersStats
      })
  },

  downloadAllUsersStats({ commit, state, rootState }, payload) {
    return axios.get('/api/users_stats', {
      params: { ...payload, format: 'xls' },
    })
  },
}
